import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../features/auth/authSlice';
import feedbackReducer from '../features/feedback/feedbackSlice';
import analyticsReducer from '../features/analytics/analyticsSlice';
import googleReviewsReducer from '../features/googleReviews/googleReviewsSlice';
import brandReducer from '../features/brand/brandSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    feedback: feedbackReducer,
    analytics: analyticsReducer,
    googleReviews: googleReviewsReducer,
    brand: brandReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch; 